import { render, staticRenderFns } from "./WidgetPromoBanner.vue?vue&type=template&id=7b059464"
import script from "./WidgetPromoBanner.vue?vue&type=script&lang=js"
export * from "./WidgetPromoBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports